export default "__VITE_ASSET__db0505c7__"